<template>
  <div class="contactInfo">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="getContactInfo"
            >
              取消
            </button>
            <button
              type="button"
              @click="$refs.submit.click()"
              class="btn btn-light"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
      <form @submit.prevent="upDate">
        <div class="row">
          <div class="col-lg-6 mb-3">
            <div class="card">
              <div class="card-body">
                <div class="mb-3">
                  <label for="company" class="form-label required"
                    >公司名稱</label
                  >
                  <input
                    v-model="form.company"
                    type="text"
                    class="form-control"
                    id="company"
                    required
                  />
                  <div class="form-text">
                    除了聯絡資訊外，還會用於 Copyright 版權宣告上。
                  </div>
                </div>
                <div class="mb-3">
                  <label for="phone" class="form-label">公司電話</label>
                  <input
                    v-model="form.phone"
                    type="text"
                    class="form-control"
                    id="phone"
                  />
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label">公司信箱</label>
                  <input
                    v-model="form.email"
                    type="email"
                    class="form-control"
                    id="email"
                  />
                </div>
                <div class="mb-3">
                  <label for="address" class="form-label">公司地址</label>
                  <input
                    v-model="form.address"
                    type="address"
                    class="form-control"
                    id="email"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mb-3">
            <div class="card" style="height: 100%">
              <div class="card-body">
                <div class="mb-3">
                  <label for="account_twitter" class="form-label"
                    >LINE</label
                  >
                  <div class="input-group mb-3">
                    <span class="input-group-text">line.me/R/ti/p/</span>
                    <input
                      v-model="form.account_twitter"
                      type="text"
                      class="form-control"
                      id="account_twitter"
                      placeholder="請輸入 LINE 官方 ID"
                    />
                  </div>
                </div>
                <div class="mb-3">
                  <label for="account_facebook" class="form-label"
                    >Facebook</label
                  >
                  <div class="input-group mb-3">
                    <span class="input-group-text">facebook.com/</span>
                    <input
                      v-model="form.account_facebook"
                      type="text"
                      class="form-control"
                      id="account_facebook"
                      placeholder="username"
                    />
                  </div>
                </div>
                <div class="mb-3">
                  <label for="account_instagram" class="form-label"
                    >Instagram</label
                  >
                  <div class="input-group mb-3">
                    <span class="input-group-text">instagram.com/</span>
                    <input
                      v-model="form.account_instagram"
                      type="text"
                      class="form-control"
                      id="account_instagram"
                      placeholder="username"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button ref="submit" type="submit" class="d-none"></button>
        <div class="text-end mb-3">
          <button
            type="button"
            class="btn btn-secondary me-3"
            @click="getContactInfo"
          >
            取消
          </button>
          <button
            type="button"
            @click="$refs.submit.click()"
            class="btn btn-gradient"
          >
            儲存
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { contactInfo } from '@/http/api/contactInfo.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

const defaultModalDate = {
  company: null,
  phone: null,
  email: null,
  address: null,
  account_twitter: null,
  account_facebook: null,
  account_instagram: null
}

export default {
  name: 'ContactInfo',
  components: { Title, Breadcrumb },
  data () {
    return {
      errMsg: null,
      errMsgKey: {
        company: '公司名稱',
        phone: '公司電話',
        email: '公司信箱',
        address: '公司地址',
        account_twitter: 'Twitter',
        account_facebook: 'Facebook',
        account_instagram: 'Instagram'
      },
      form: JSON.parse(JSON.stringify(defaultModalDate))
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    }
  },
  methods: {
    ...mapMutations([
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey'
    ]),
    initialEvent () {
      const vm = this
      vm.getContactInfo()
    },
    getContactInfo () {
      const vm = this
      vm.Loading()
      contactInfo
        .get(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.form = res.data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    upDate () {
      const vm = this
      vm.Loading()
      contactInfo
        .update(vm.form, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
